(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-por-sprint', {
            parent: 'app',
            url: '/chamados-por-sprint',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório das movimentações das demandas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-por-sprint/chamados-por-sprint.html',
                    controller: 'ChamadosPorSprintController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('severidade');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
